import { api } from '~/services/api';
import { AxiosError } from 'axios';
import ICustomAxiosRequestConfig from '~/services/custom/ICustomAxiosRequestConfig';

type UnitParams = {
  unit_id: string;
};

export type UnitProps = {
  id: string;
  name: string;
};

type GetUnitProps = {
  data?: UnitProps;
  status?: number;
  message?: string;
};

type UnitOptions = {
  initialData?: {
    data: UnitProps;
  };
  keepPreviousData?: boolean;
};

export const getUnit = async (
  params?: UnitParams,
  serverSide?: { serverSide: boolean }
): Promise<GetUnitProps> => {
  try {
    const { unit_id } = params as UnitParams;
    const { data, status } = await api.get(`/restaurant/v1/units/${unit_id}`, {
      serverSide,
    } as ICustomAxiosRequestConfig);

    return {
      data: data.data,
      status,
    };
  } catch (err) {
    const error = err as AxiosError;

    return {
      message: (error.response?.data as any).message,
      status: error.response?.status,
    };
  }
};
